import Bred from '../assets/images/bred.png';
import Bridge from '../assets/images/bridge.png';
import Pepiniere from '../assets/images/pepiniere.jpg';
import Fintecture from '../assets/images/fintecture.png';
import AwsStartups from '../assets/images/aws-startups.jpg';
import Auvalie from '../assets/images/auvalie.png';
import FoundersHub from '../assets/images/foundershub.jpeg';
import FrenchTech from '../assets/images/french-tech.png';
import DeepTech from '../assets/images/deeptech.png';
import Cea from '../assets/images/cea.png';
import BpPrize from '../assets/images/bp-prize.png';
import CciParis from '../assets/images/cci-paris.png';

export const Offer = () => {
  return (
    <section id='offer' className='bd-container'>
      <div className='section-container'>
        <h1>Nos offres</h1>
        <p>Des modèles prêts à l’emploi et des itérations sans limites...</p>
        <div className='offer'>
          <div className='offer_item'>
            <h2 className='text-center subtitle'>Vous disposez déjà des images de votre territoire:</h2>
            <ul className='offer_item-content'>
              <li>Détectez les objets déjà disponible dans la bibliothèque BPartners (toits, piscine, arbres,
                panneaux solaires, espaces verts, surfaces agricoles)
              </li>
            </ul>
            <span className='add-object'>+ AJOUTEZ vos propres objets d‘intérêts vos propres objets d‘intérêt</span>
            <button className='button_style'>
              <a
                href='https://meet.brevo.com/bpartnersartisans/detection-dobjets-par-intelligence-artificielle-bpartners'
                rel='noreferrer'
                target='_blank'
              >
                CONTACTEZ-NOUS
              </a>
            </button>
          </div>
          <div className='offer_item'>
            <h2 className='text-center subtitle'>Vous ne disposez PAS d’images de votre territoire:</h2>
            <ul className='offer_item-content'>
              <li>Nous collectons les images de votre territoire.</li>
              <li>Détectez les objets déjà disponible dans la bibliothèque BPartners (toits, piscine, arbres,
                panneaux solaires, espaces verts, surfaces agricoles)
              </li>
            </ul>
            <span className='add-object'>+ AJOUTEZ vos propres objets d‘intérêts vos propres objets d‘intérêt</span>
            <button className='button_style'>
              <a
                href='https://meet.brevo.com/bpartnersartisans/detection-dobjets-par-intelligence-artificielle-bpartners'
                rel='noreferrer'
                target='_blank'
              >
                CONTACTEZ-NOUS
              </a>
            </button>
          </div>
        </div>
        <h3 className='text-center trust-subtitle'>Ils nous font déjà confiance</h3>
        <ul className='award_list'>
          <li>Entreprise by Commissariat à l’Energie Atomique “CEA”, labélisée French Tech Seed et Deeptech par BPI
            France pour notre IA souveraine.
          </li>
          <li>Collectivités françaises (exécution sur une agglomération de 100Km2 sur plusieurs objets d‘intérêts).
          </li>
          <li>Lauréat de l'entreprise innovante 2022 par CCI & Banque Populaire IDF.</li>
        </ul>
        <div className='partners'>
          <div className='partners_item'>
            <h3 className='partners_item-title'>Partenaires</h3>
            <div className='partners_image_container-row'>
              <div className='partners_image_container-y'>
                <img src={Bred} alt='Bred Logo'
                     style={{ objectFit: 'contain', maxWidth: '110px', marginBottom: '1.3rem' }} />
                <img src={Bridge} alt='Bridge Logo'
                     style={{ objectFit: 'contain', maxWidth: '110px', marginBottom: '.9rem' }} />
                <img src={Pepiniere} alt='Pepiniere Logo'
                     style={{ objectFit: 'contain', maxWidth: '110px', marginBottom: '.9rem' }} />
                <img src={FrenchTech} alt='FrenchTech Logo'
                     style={{
                       objectFit: 'contain',
                       maxWidth: '70px',
                       marginBottom: '.9rem'
                }} />
              </div>
              <div className='partners_image_container-y'>
                <img src={Fintecture} alt='Fintecture Logo'
                     style={{ objectFit: 'contain', maxWidth: '100px', marginBottom: '.9rem' }} />
                <img src={AwsStartups} alt='AwsStartups Logo'
                     style={{ objectFit: 'contain', maxWidth: '110px', marginBottom: '.9rem' }} />
                <img src={FoundersHub} alt='FoundersHub Logo'
                     style={{ objectFit: 'contain', maxWidth: '110px' }} />
                <img src={Auvalie} alt='Auvalie Logo'
                     style={{
                       objectFit: 'contain',
                       maxWidth: '90px',
                       marginTop: '1.5rem'
                     }} />
              </div>
            </div>
          </div>
          <div className='partners_item'>
            <h3 className='partners_item-title'>Labélisation 2023</h3>
            <div className='partners_image_container-row'>
              <img src={DeepTech} alt='DeepTech Logo' style={{ objectFit: 'contain', maxWidth: '255px' }} />
            </div>
          </div>
          <div className='partners_item'>
            <h3 className='partners_item-title'>Partenaire scientifique</h3>
            <div className='partners_image_container-col'>
              <img src={Cea} alt='Cea Logo' style={{ objectFit: 'contain', maxWidth: '120px' }} />
              <p>List ExpressIf</p>
            </div>
          </div>
          <div className='partners_item'>
            <h3 className='partners_item-title'>Distinctions</h3>
            <div className='partners_image_container-col'>
              <img src={BpPrize} alt='BpPrize' style={{ objectFit: 'contain', maxWidth: '255px' }} />
              <img src={CciParis} alt='CciParis Logo'
                   style={{ objectFit: 'contain', maxWidth: '175px', marginBlock: '2rem' }} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};